module.exports = __webpack_public_path__ + "assets/img/no-tip.b76d9e7d.png";